export const LIBRARY_ROUTE = 'library'
export const CONTENT_ROUTE = 'content'
export const GAME_FEATURED_ROUTE = 'game-featured'
export const LOCALISATION_ROUTE = 'localisation'
export const FOUROHFOUR_ROUTE = 'FourOhFour'

// MODS
export const MOD_BROWSE_ROUTE = 'mod-browse-list'
export const MOD_BROWSE_ROUTE_TOKEN_PACKS = 'mod-browse-list-token-packs'
export const MOD_VIEW_ROUTE = 'mod-view'
export const MOD_ADD_ROUTE = 'mod-add'
export const MOD_ADMIN_ROUTE = 'mod-admin'
export const MOD_ADMIN_SETTINGS_ROUTE = `${MOD_ADMIN_ROUTE}-settings`

// Collections
export const COLLECTION_BROWSE_ROUTE = 'collection-browse-list'
export const COLLECTION_VIEW_ROUTE = 'collection-view'

// FEATURED (stubs)
export const GAME_FEATURED_PREVIEW_ROUTE = 'game-featured-preview'

// GUIDES
export const GUIDE_BROWSE_ROUTE = 'guide-browse-list'
export const GUIDE_VIEW_ROUTE = 'guide-view-route'

// USERS
export const USER_COLLECTION_BROWSE_ROUTE = 'user-collections'
export const USER_GUIDE_BROWSE_ROUTE = 'user-guides'
export const USER_MOD_BROWSE_ROUTE = 'user-mods'
export const USER_GAME_MOD_BROWSE_ROUTE = 'user-mods' // Re-use above link
export const USER_GAME_COLLECTION_BROWSE_ROUTE = 'user-game-collections'
export const USER_ROUTE = 'user'
